// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Shelf } from './Shelf';

//COMPONENT

class PlanogramItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            shelfGroups: [],
            selectedShelf: {},
            selectedProduct: {}
        };

        this.availableSlotsUpdated = this.availableSlotsUpdated.bind(this);
        this.deselectProduct = this.deselectProduct.bind(this);
        this.shelfSelected = this.shelfSelected.bind(this);
    }

    componentDidMount(){
        let shelfGroups = JSON.parse(JSON.stringify(this.props.shelfGroups));
        for(let shelfGroup of shelfGroups){
            shelfGroup.shelves.reverse();
        }
        this.setState({shelfGroups: shelfGroups});
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(this.props.shelfGroups) != JSON.stringify(prevProps.shelfGroups)){
            let shelfGroups = JSON.parse(JSON.stringify(this.props.shelfGroups));
            for(let shelfGroup of shelfGroups){
                shelfGroup.shelves.reverse();
            }
            this.setState({shelfGroups: shelfGroups});
        }

        if(JSON.stringify(this.props.selectedShelf) != JSON.stringify(prevProps.selectedShelf)){
            this.setState({selectedShelf: this.props.selectedShelf});
        }

        if(this.props.selectedProduct != prevProps.selectedProduct){
            this.setState({
                selectedProduct: this.props.selectedProduct,
                selectedShelf: {},
                showSlider: false
            });
        }
    }

    availableSlotsUpdated(slots){
        this.props.availableSlotsUpdated(slots);
    }

    deselectProduct(){
        this.props.deselectProduct();
        this.setState({
            showSlider: false,
            selectedShelf: {}
        });
    }

    shelfSelected(shelf){
        this.props.shelfSelected(shelf);
    }

    render() {
        let id = 0;
        return (
            <div>
                <div className="shelf-group-container">
                    {this.state.shelfGroups.map((shelfGroup) => {
                        return(
                            <div key={id++} className="shelf-group" style={{maxWidth: String(100 / this.state.shelfGroups.length) + '%'}}>
                                {shelfGroup.shelves.map((shelf) => {
                                    return (<Shelf key={shelf.node} shelf={shelf} selectedShelf={this.state.selectedShelf} selectedProduct={this.state.selectedProduct} avialbleSlotsForProduct={this.availableSlotsUpdated} shelfSelected={this.shelfSelected}/>);
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

PlanogramItem.propTypes = {
    history: PropTypes.object.isRequired,
    shelfGroups: PropTypes.array.isRequired,
    selectedProduct: PropTypes.object.isRequired,
    deselectProduct: PropTypes.func.isRequired,
    updateShelfGroups: PropTypes.func.isRequired,
    shelfSelected: PropTypes.func.isRequired,
    availableSlotsUpdated: PropTypes.func.isRequired,
    selectedShelf: PropTypes.object.isRequired
};

const hoc = withRouter(PlanogramItem);

// EXPORT COMPONENT
export { hoc as PlanogramItem };


// WEBPACK FOOTER //
// ./src/components/pages/Planograms/PlanogramItem.js